import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Row, Col, Card, Icon, Button } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import VehiclesForm from './VehiclesForm'
import Image from 'react-image-resizer';

const API_HOST_URL = process.env.REACT_APP_API_URL

class Vehicles extends Component {

    state = {
        vehicles: [],
        vehicle: {},
        visible: false,
        requestType: ''
    }

    componentDidMount() {
        this.fetchData();
    }

    fetchData() {
        axios.get(`${API_HOST_URL}/api/userprofile/vehicles/?user=${this.props.loggedInUser.pk}`)
            .then(res => {
                this.setState({
                    vehicles: res.data
                },
                    () => {
                        console.log("vehicles fetched: ", this.state.vehicles)
                    })
            })
    }

    showModal = (type) => {
        if (type === 'post') {
            //no data should be passed to dialog form
            this.setState({ vehicle: {} });
        }

        this.setState({ visible: true, requestType: type });
    }

    saveFormRef = (formRef) => {
        this.formRef = formRef;
    }

    handleCreate = () => {
        const form = this.formRef.props.form;
        const requestType = this.state.requestType;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            console.log("values are here: ", values)
            let formData = new FormData();
            formData.append('vehicleModel', values.vehicleModel);
            formData.append('color', values.color);
            formData.append('numberPlate', values.numberPlate);
            formData.append('vehiclePhoto', values.vehiclePhoto[0].originFileObj);
            formData.append('lagguageAllowed', values.lagguageAllowed);
            formData.append('user', this.props.loggedInUser.pk);

            switch (requestType) {

                case 'post':
                    return axios.post(`${API_HOST_URL}/api/userprofile/vehicles/`,
                        formData,
                        {
                            headers: {
                                Authorization: 'Token ' + this.props.token,
                                'Content-Type': 'multipart/form-data'
                            }
                        })
                        .then(res => {
                            console.log(res)
                            form.resetFields();
                            this.setState({ visible: false });
                            this.fetchData()
                        })
                        .catch(error => console.log(error));

                // case 'put':
                //     return axios.put(`${API_HOST_URL}/api/systemsetup/costcenter/${this.state.costCenter.id}/`, {
                //      costCenter: values.costCenter
                //     },
                //     {
                //       headers: {Authorization: 'Token ' + this.props.token}  
                //     })
                //         .then(res => {
                //           console.log(res)
                //           form.resetFields();
                //           this.setState({ visible: false });
                //           this.fetchData()
                //     })
                //         .catch(error => console.err(error));

                default: return;
            }
        });
    }

    onPrimaryVehicleSelect(vehicle) {
         axios.patch(`${API_HOST_URL}/api/userprofile/vehicles/${vehicle.id}/`, {
            primaryVehicle: true//!vehicle.primaryVehicle
        },
            {
                headers: { Authorization: 'Token ' + this.props.token }
            })
            .then(res => {
                console.log(res)
                this.fetchData()
            })
            .catch(error => console.err(error));
    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    handleDelete = (record) => {
        return axios.delete(`${API_HOST_URL}/api/userprofile/vehicles/${record.id}/`,
            {
                headers: { Authorization: 'Token ' + this.props.token }
            })
            .then(res => {
                console.log(res)
                this.fetchData()
            })
            .catch(error => console.log(error));
    }

    render() {
        const { Meta } = Card;
        const { vehicles } = this.state;

        return (
            <div>
                <h1>Vehicles</h1>
                <Button type="primary" size="large" onClick={() => this.showModal('post')}>
                    Add Vehicle
                </Button>
                <br />
                <br />
                <Row>
                    {
                        vehicles.map(vehicle => (
                            <Col md={{ span: 12 }} key={vehicle.id}>
                                <Card
                                    style={{ width: 300, marginBottom: 24 }}
                                    cover={
                                        // <img
                                        //     alt="example"
                                        //     src={vehicle.vehiclePhoto}
                                        // />
                                        <Image
                                            src={vehicle.vehiclePhoto}
                                            height={240}
                                            width={240}
                                        />
                                    }
                                    actions={[
                                        <Icon type="edit" key="edit" />,
                                        <Icon type="delete" key="delete" onClick={() => this.handleDelete(vehicle)} />,
                                        <Icon type="check-circle" theme="filled" style={{ color: `${vehicle.primaryVehicle == true ? '#00acff' : ''}` }} onClick={() => this.onPrimaryVehicleSelect(vehicle)} />
                                    ]}
                                >
                                    <Meta
                                        title={vehicle.numberPlate}
                                        description={vehicle.vehicleModel + ', ' + vehicle.color}
                                    />
                                </Card>
                            </Col>
                        ))
                    }

                </Row>

                <VehiclesForm
                    wrappedComponentRef={this.saveFormRef}
                    visible={this.state.visible}
                    onCancel={this.handleCancel}
                    onCreate={this.handleCreate}
                    data={this.state.vehicle} />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.token !== null,
        token: state.token,
        loggedInUser: state.currentUser
    }
}

export default connect(mapStateToProps, null)(Vehicles);

